import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import { Wrapper as IconWrapper } from 'components/shared/Icon/styles'
import { Wrapper as InfoWrapper } from 'components/shared/Info/styles'
import Text from 'components/shared/Text/'

export const Wrapper = styled(Box)`
    ${({ theme }) => {
        if (theme.mode === 'dark') {
            return css`
                ${InfoWrapper} {
                    /* TODO: Wyjątek został z black friday. 
                    Zrobiło się zamieszanie z kolorami i to był wyjątek ciężki do obejścia z jakiegoś powodu.
                    Do skontrolowania po ponownym włączeniu promocji */
                    border-color: #858dad !important;

                    ${Text} {
                        color: ${theme.colors.grayscale_400} !important;
                    }
                }
                ${IconWrapper} {
                    color: ${theme.colors.grayscale_400} !important;
                }
            `
        }
    }};
`
